import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const AdminPrivateRoute = () => {
  const location = useLocation();
  const panelRole = localStorage
    .getItem("panelRole")
    ?.trim()
    ?.toLowerCase();
  const adminToken = localStorage.getItem("adminToken");
  const leaveOnlyPaths = [
    "/panel-admin/leave-requests",
    "/panel-admin/leave-statistics",
  ];
  const isLeavePath = leaveOnlyPaths.some((path) =>
    location.pathname.startsWith(path),
  );
  const isLeaveRole = panelRole === "hr" || panelRole === "accounts";
  const isAdmin = panelRole === "admin";

  if (!adminToken || !["admin", "hr", "accounts"].includes(panelRole)) {
    return <Navigate to="/" replace />;
  }

  if (isLeaveRole && !isLeavePath) {
    return <Navigate to="/panel-admin/leave-requests" replace />;
  }

  if (isAdmin && isLeavePath) {
    return <Navigate to="/panel-admin/dashboard" replace />;
  }

  return <Outlet />;
};

export default AdminPrivateRoute;
